<template>
  <div class="table">
    <div class="top">
      <Form ref="formInline" :model="formInline" :label-width="100">
        <Row>
          <!--          <Col :span="6">-->
          <!--            <FormItem label="产品标题: ">-->
          <!--              <Input v-model="formInline.productTitle" placeholder="请输入"> </Input>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <!--          <Col :span="6">-->
          <!--            <FormItem label="申请文件名称: ">-->
          <!--              <Input v-model="formInline.fileName" placeholder="请输入"> </Input>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <Col :span="6">
            <FormItem label="状态: ">
              <Select v-model="formInline.state" placeholder="请选择">
                <Option value="">全部</Option>
                <Option value="0">未审批</Option>
                <Option value="1">通过</Option>
                <Option value="2">拒绝</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem :label-width="20">
              <Button @click="getData" type="primary">搜索</Button>
              <Button style="margin-left: 5px" @click="refsh">重置</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!-- <Button type="primary" class="add" @click="handlerClick('add', null)"
          >新增</Button
        > -->
      <!-- <Button type="error" class="remove" @click="batchRemove"
          >批量删除</Button
        > -->
    </div>
    <Table height="450" :columns="columns" :data="data">
      <template slot="Controls" slot-scope="{ row }">
        <Button class="table_button" type="primary" size="small" @click="handleSearch(row)"
          >查看</Button
        >
        <!-- <Button
          class="table_button"
          size="small"
          type="warning"
          :disabled="row.state === 1 || row.state === 0"
          @click="handleApprove(row)"
          >审批</Button
        > -->
      </template>
    </Table>
    <Page
      :total="total"
      size="small"
      show-total
      show-elevator
      @on-change="changePage"
      @on-page-size-change="changeSize"
      style="float: right; margin-top: 5px"
    />
    <Spin v-if="downLoading" fix></Spin>
    <Drawer title="" v-model="drawerVisible" width="50%" :transfer="false" :inner="true">
      <div style="padding-top: 20px">
        <Table :columns="columns1" highlight-row :data="tableData" height="558" style="width: 100%">
          <template #action="{ row, index }">
            <Button type="error" size="small" @click="downloadHistory(row)">下载</Button>
          </template>
          <template #productType="{ row }">
            {{ functionName(row) }}
          </template>
        </Table>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { findMyDownloadApplication, download } from '@/api/CensusProgress';
export default {
  props:['applyDialog'],
  data() {
    return {
      total: 0,
      drawerVisible:false,
      data: [],
      downLoading: false,
      formInline: {
        fileName: '',
        state: '',
        productTitle: '',
      },
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        // { type: 'selection', width: 60, align: 'center' },
        // { title: "产品编号", align: "center", key: "productNumber" },
        { title: '申请时间', align: 'center', key: 'createTime' },
        // { title: '产品名称', align: 'center', key: 'productTitle' },
        // { title: '申请文件名称', align: 'center', key: 'fileName' },
        {
          title: '申请状态',
          align: 'center',
          key: 'state',
          render(h) {
            return h(
              'span',
              this.row.state === 0
                ? '未审批'
                : this.row.state === 1
                ? '通过'
                : this.row.state === 2
                ? '拒绝'
                : '未审批'
            );
          },
        },

        { title: '申请描述', align: 'center', key: 'describe' },
        { title: '拒绝原因', align: 'center', key: 'reason' },
        { title: '有效期', align: 'center', key: 'validityPeriod' },
        { title: '操作', align: 'center', slot: 'Controls', width: 100 },
      ],
      columns1:[
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        { title: '名称', align: 'center', key: 'productName' },
        { title: '类型', align: 'center', key: 'productType', slot: 'productType', },
        {
          title: '操作',
          key: 'action',
          width: 180,
          slot: 'action',
          align: 'center',
        }
      ],
      tableData:[],
      page: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  watch:{
    applyDialog:function(val){
      this.getData();
    }
  },
  created() {

  },
  mounted() {
    this.getData();
  },
  methods: {
    functionName(num){
      switch (num.categoryOne) {
        case '1':
          return '图鉴'
          break;
        case '2':
          return '期刊'
          break;
        case '3':
          return '成果报告'
          break;
        case '4':
          return '文创产品'
          break;
      }
    },
    handleSearch(row){
      this.drawerVisible = true
      this.tableData = row.censusProductsList
    },
    downloadHistory(item) {
      this.downLoading = true;
      download({ id: item.id}).then((res) => {
        this.downLoading = false;
        const blob = new Blob([res], { type: 'application/ocet-stream' });
        const dom = document.createElement('a');
        const downUrl = window.URL.createObjectURL(blob);
        dom.href = downUrl;
        dom.download = item.relatedDocumentFile.name;
        dom.style.display = 'none';
        document.body.appendChild(dom);
        dom.click();
        dom.parentNode.removeChild(dom);
        window.URL.revokeObjectURL(downUrl);
      });
    },
    refsh() {
      this.formInline.productTitle = '';
      this.formInline.state = '';
      this.formInline.fileName = '';
      this.getData();
    },
    changePage(page) {
      this.page.pageNumber = page;
      this.getData();
      // this.$emit('changePage', page);
    },
    changeSize(size) {
      this.page.pageSize = size;
      this.getData();
      // this.$emit('changeSize', size);
    },
    getData() {
      findMyDownloadApplication({
        pageNumber: this.page.pageNumber,
        pageSize: this.page.pageSize,
        ...this.formInline,
      }).then((res) => {
        this.data = res.result.records;
        this.total = res.result.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/header/outherPage/applyDownHistory.vue